import { useEffect } from "react";
import { datadogRum, RumInitConfiguration } from "@datadog/browser-rum";

interface Props extends RumInitConfiguration {
  readonly enabled?: boolean | undefined;
  readonly sessionReplayRecording?: boolean | undefined;
}

export function useDatadogRum(props: Readonly<Props>) {
  const { enabled, sessionReplayRecording, ...rumInitConfiguration } = props;

  useEffect(() => {
    if (!enabled) return;

    datadogRum.init(rumInitConfiguration);

    if (sessionReplayRecording) {
      datadogRum.startSessionReplayRecording();
    }

    return () => {
      datadogRum.stopSessionReplayRecording();
    };
  }, [enabled, sessionReplayRecording, rumInitConfiguration]);
}
